/* Ryedical — newproductpage interactions
   1. Image gallery thumb-to-main swap
   2. FAQ accordion
   3. Mobile sticky ATC bar visibility via IntersectionObserver
   4. Smooth-scroll back to hero buy block from final CTA + sticky button
*/
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function initGallery(root) {
    var gallery = $('.ry-npp-gallery', root);
    if (!gallery || gallery.dataset.ryBound === '1') return;
    gallery.dataset.ryBound = '1';
    var main = $('.ry-npp-gallery__main img', gallery);
    var thumbs = $$('.ry-npp-gallery__thumb', gallery);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.dataset.fullSrc;
        var alt = t.dataset.fullAlt || '';
        if (main && src) {
          main.src = src;
          main.alt = alt;
        }
      });
    });
  }

  function initFaq(root) {
    $$('.ry-npp-faq__item', root).forEach(function (item) {
      var btn = $('.ry-npp-faq__q', item);
      if (!btn || btn.dataset.ryBound === '1') return;
      btn.dataset.ryBound = '1';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var nowOpen = !item.classList.contains('is-open');
        item.classList.toggle('is-open', nowOpen);
        btn.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      });
    });
  }

  function initStickyBar() {
    var sticky = $('.ry-npp-sticky');
    var hero = $('.ry-npp-hero');
    if (!sticky || !hero || sticky.dataset.ryBound === '1') return;
    sticky.dataset.ryBound = '1';
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { rootMargin: '-100px 0px 0px 0px', threshold: 0 });
    observer.observe(hero);
  }

  function scrollToBuy() {
    var target = $('.ry-npp-block--buy') || $('.ry-npp-panel') || $('.ry-npp-hero');
    if (target) {
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  function initFinalCta() {
    var btn = $('.ry-npp-final__btn');
    if (!btn || btn.dataset.ryBound === '1') return;
    btn.dataset.ryBound = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToBuy();
    });
  }

  function initStickyClick() {
    var sticky = $('.ry-npp-sticky');
    if (!sticky) return;
    var btn = $('.ry-npp-sticky__btn', sticky);
    if (!btn || btn.dataset.ryBound === '1') return;
    btn.dataset.ryBound = '1';
    btn.addEventListener('click', function () {
      scrollToBuy();
    });
  }

  function init() {
    initGallery(document);
    initFaq(document);
    initStickyBar();
    initFinalCta();
    initStickyClick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
